import React from 'react';
import PropTypes from 'prop-types';
import { Collapse, List } from '@pella/sash-framework';
import { CTA, Image } from '../../../';

const ProMenu = ({ data, children }) => (
	<List
		bullets='none'
		className='mobileProMenu invisible absolute -right-80 top-0 z-[11] h-[calc(100svh-59px)] w-full overflow-hidden bg-neutral-25 shadow-xl motion-safe:transition-all motion-safe:duration-500 sm:h-[calc(100svh-63px)]'
	>
		{children}

		{data.category?.find((cat) => cat.category_type === 'pro type') && (
			<li>
				<Collapse
					className='!border-0 bg-white'
					isOpen
				>
					<Collapse.Trigger className='bg-white !px-4 !py-2 text-sm font-semibold'>{data.category?.find((cat) => cat.category_type === 'pro type')?.heading}</Collapse.Trigger>

					<Collapse.Content className='bg-neutral-25 !px-4 !py-2 shadow-inner'>
						<List
							bullets='none'
							className='grid grid-cols-2 gap-4 py-4'
						>
							{data.category
								?.find((cat) => cat.category_type === 'pro type')
								.entries?.map((entry, index) => (
									<li key={index}>
										<CTA
											data={entry}
											className='block text-center font-semibold leading-tight no-underline [&>span:first-child]:mx-auto [&>span:first-child]:mb-2.5 [&>span:first-child]:flex [&>span:first-child]:h-16 [&>span:first-child]:w-16 [&>span:first-child]:items-center [&>span:first-child]:justify-center [&>span:first-child]:rounded-full [&>span:first-child]:bg-primary [&>span:first-child]:text-4xl'
										/>
									</li>
								))}
						</List>
					</Collapse.Content>
				</Collapse>
			</li>
		)}

		{data.category?.find((cat) => cat.category_type === 'resources') && (
			<li className='bg-white'>
				<Collapse
					className='!border-0'
					isOpen
				>
					<Collapse.Trigger className='!px-4 !py-2 text-sm font-semibold'>{data.category?.find((cat) => cat.category_type === 'resources')?.heading}</Collapse.Trigger>
					<Collapse.Content className='bg-neutral-25 !px-4 !py-2 shadow-inner'>
						<List
							bullets='none'
							className='py-1.5'
						>
							{data.category
								?.find((cat) => cat.category_type === 'resources')
								.entries?.map((entry, index) => (
									<li key={index}>
										<CTA
											data={entry}
											className='inline-block py-1.5 font-semibold no-underline'
										/>
									</li>
								))}
						</List>
					</Collapse.Content>
				</Collapse>
			</li>
		)}

		{data.category?.find((cat) => cat.category_type === 'tools') && (
			<li className='bg-white'>
				<Collapse
					className='!border-0'
					isOpen
				>
					<Collapse.Trigger className='!px-4 !py-2 text-sm font-semibold'>{data.category?.find((cat) => cat.category_type === 'tools')?.heading}</Collapse.Trigger>
					<Collapse.Content className='bg-neutral-25 !px-4 !py-2 shadow-inner'>
						<List
							bullets='none'
							className='py-1.5'
						>
							{data.category
								?.find((cat) => cat.category_type === 'tools')
								.entries?.map((entry, index) => (
									<li key={index}>
										<CTA
											data={entry}
											className='inline-block py-1.5 font-semibold no-underline'
										/>
									</li>
								))}
						</List>
					</Collapse.Content>
				</Collapse>
			</li>
		)}

		{data.category?.find((cat) => cat.category_type === 'feature') && (
			<li className='px-4 py-6'>
				<List
					bullets='none'
					className='space-y-6'
				>
					{data.category
						.find((cat) => cat.category_type === 'feature')
						.group.map((feat, index) => (
							<li key={index}>
								{feat.cta?.length === 1 ? (
									<CTA
										data={feat.cta[0]}
										className='block no-underline'
									>
										<Image
											data={{ image: feat.file }}
											className='mb-2 !block h-32 w-full !object-cover'
										/>

										{feat.heading && <p className='mb-1 text-base font-semibold'>{feat.heading}</p>}
										{feat.subheading && <div dangerouslySetInnerHTML={{ __html: feat.subheading }} />}
									</CTA>
								) : (
									<>
										<Image
											data={{ image: feat.file }}
											className='mb-2 !block h-32 w-full !object-cover'
										/>

										{feat.heading && <p className='mb-1 text-base font-semibold'>{feat.heading}</p>}
										{feat.subheading && <div dangerouslySetInnerHTML={{ __html: feat.subheading }} />}

										{feat.cta.map((cta, index) => (
											<p
												className='my-2'
												key={index}
											>
												<CTA
													data={{ ...cta, material_icon: 'keyboard_arrow_right' }}
													className='flex flex-row-reverse items-center justify-end text-sm font-semibold no-underline [&>span]:ml-1'
												/>
											</p>
										))}
									</>
								)}
							</li>
						))}
				</List>
			</li>
		)}
	</List>
);

ProMenu.propTypes = {
	data: PropTypes.object.isRequired,
	children: PropTypes.node,
};

export default ProMenu;
